import type { Selector } from "@overmap-ai/core"

import type { RootState } from "../typings"

export const selectSessionExpired: Selector<RootState, boolean> = (state) => state.session.sessionExpired
